import { ModelProperties } from "./ModelProperties";

/**
 *
 */
export class ModelBase {
  /**
   */
  public storageKey: string = `game-data`;

  /**
   */
  public version: string = `0.0.0`;

  /**
   */
  public properties: ModelProperties = {};

  /**
   */
  serialize() {
    return JSON.stringify({
      version: this.version,
      properties: this.properties
    });
  }

  /**
   */
  deSerialize(serialized) {
    const parsed = JSON.parse(serialized);
    this.version = parsed.version;
    this.properties = parsed.properties;
  }
}
